import { createSlice } from "@reduxjs/toolkit";

const websocketSlice = createSlice({
  name: "websocket",
  initialState: {
    messages: [],
    status: "disconnected",
    error: null,
    rooms: [],
    currentRoom: null,
  },
  reducers: {
    websocketConnected: (state) => {
      state.status = "connected";
      state.error = null;
    },
    websocketDisconnected: (state) => {
      state.status = "disconnected";
    },
    websocketError: (state, action) => {
      state.status = "error";
      state.error = action.payload;
    },
    websocketMessageReceived: (state, action) => {
      state.messages.push(action.payload);
    },
    setRooms: (state, action) => {
      state.rooms = action.payload;
    },
    setCurrentRoom(state, action) {
      state.currentRoom = action.payload;
    },
  },
});

export const {
  websocketConnected,
  websocketDisconnected,
  websocketError,
  websocketMessageReceived,
  setRooms,
  setCurrentRoom,
} = websocketSlice.actions;

export default websocketSlice.reducer;
